import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { ISessionState, Lang } from '@platform/core/types';

const initialState: ISessionState = { currentWorkspaceId: null, lang: 'uk', devUser: null, colorScheme: 'parliament' };

/** Сесійний стан клієнта: поточний воркспейс, мова, схема, Dev-користувач. Персистується (state/persistence). */
export const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    workspaceSelected(state, action: PayloadAction<string | null>) { state.currentWorkspaceId = action.payload; },
    langChanged(state, action: PayloadAction<Lang>) { state.lang = action.payload; },
    devUserChanged(state, action: PayloadAction<string | null>) { state.devUser = action.payload; },
    colorSchemeChanged(state, action: PayloadAction<string>) { state.colorScheme = action.payload; },
    sessionHydrated(_state, action: PayloadAction<Partial<ISessionState>>) { return { ...initialState, ...action.payload }; },
  },
});

export const { workspaceSelected, langChanged, devUserChanged, colorSchemeChanged, sessionHydrated } = sessionSlice.actions;
